import React from "react";

export type ViewMode = "grid" | "list";

interface ViewModeToggleProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  className?: string;
}

export const ViewModeToggle: React.FC<ViewModeToggleProps> = ({
  viewMode,
  onViewModeChange,
  className = "",
}) => {
  return (
    <div className={`flex bg-gray-100 rounded-lg p-1 ${className}`}>
      <button
        onClick={() => onViewModeChange("grid")}
        className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 ${
          viewMode === "grid"
            ? "bg-white text-gray-900 shadow-sm"
            : "text-gray-600 hover:text-gray-900"
        }`}
        title="Visualização em grade"
      >
        <span className="mr-1.5">▦</span>
        Grade
      </button>
      <button
        onClick={() => onViewModeChange("list")}
        className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 ${
          viewMode === "list"
            ? "bg-white text-gray-900 shadow-sm"
            : "text-gray-600 hover:text-gray-900"
        }`}
        title="Visualização em lista"
      >
        <span className="mr-1.5">☰</span>
        Lista
      </button>
    </div>
  );
};
